import { PuffLoader } from 'react-spinners';
import "./style.scss"

export const FixedLoader = ({ Component }) => {
return <div className="fixed-loader">{Component ? <Component /> : <PuffLoader color="#000" size={36} />}</div>;
}
